import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    deletionErrorMessage:
      'An error occurred while deleting your logo. Please try again and if the problem remains, contact us.',
    successMessage: 'Changes successfully saved!',
  },
  fr: {
    deletionErrorMessage:
      'Une erreur est survenue lors de la suppression de votre logo. Réessayez et si le problème persiste, contactez-nous.',
    successMessage: 'Modifications enregistrées avec succès\xa0!',
  },
} as const);

export default locales;
